import { Component, computed, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Stage } from '../../enums';
import { STAGE_COLORS, DEFAULT_COLORS } from './banner.config';

@Component({
    selector: 'app-banner',
    templateUrl: './banner.component.html',
    standalone: true,
    imports: [TranslateModule],
    host: {
        class: 'w-full h-[30px] flex items-center justify-center text-sm shrink-0',
        '[style.color]': 'fgColor()',
        '[style.backgroundColor]': 'bgColor()'
    }
})
export class BannerComponent {
    public readonly stage = input.required<Stage | string>();

    protected readonly fgColor = computed(() => (STAGE_COLORS.get(this.stage()) ?? DEFAULT_COLORS).fg);
    protected readonly bgColor = computed(() => (STAGE_COLORS.get(this.stage()) ?? DEFAULT_COLORS).bg);
}
